<app-tile *ngFor="let t of (show == 'primary' ? getPrimaryTiles() : items)"
          [item]="t"
          [view]="getTileView(t)"></app-tile>
